<template>
  <div>
    <h4 class="ui dividing header">{{ $t("search criteria") }}</h4>
    <div class="ui form">
      <div class="fields">
        <div class="six column wide field">
          <label>{{ $t("start date") }}</label>
          <div class="ui calendar" ref="range_start">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" :placeholder="$t('start date')" />
            </div>
          </div>
        </div>
        <div class="six column wide field">
          <label>{{ $t("end date") }}</label>
          <div class="ui calendar" ref="range_end">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" :placeholder="$t('end date')" />
            </div>
          </div>
        </div>
        <div class="four column wide field">
          <label for>{{ $t("search") }}</label>
          <div class="ui blue icon labeled fluid button" @click="search">
            <i class="find icon"></i>
            {{ $t("search") }}
          </div>
        </div>
      </div>
    </div>

    <h4 class="ui dividing header">{{ $t("instance list") }}</h4>
    <table class="ui very compact celled selectable striped table" ref="table">
      <thead>
        <tr>
          <th>{{ $t("started") }}</th>
          <th>{{ $t("status") }}</th>
          <th>{{ $t("activity") }}</th>
          <th>{{ $t("last update") }}</th>
          <th>{{ $t("options") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!items.length">
          <td colspan="5" style="text-align: center">{{ $t("no results") }}</td>
        </tr>
        <tr v-for="(item, idx) in items" :key="idx">
          <td>
            {{
              item.create_date
                | formatDate(enterprise_setup.detailed_date_format)
            }}
          </td>
          <td>
            <i :class="status(item.status_code).icon"></i>
            {{ status(item.status_code).name }}
          </td>
          <td>
            <i :class="activity(item.ngn_interaction).icon"></i>
            {{ activity(item.ngn_interaction).name }}
          </td>
          <td>
            {{
              item.last_update_date
                | formatDate(enterprise_setup.detailed_date_format)
            }}
          </td>
          <td>
            <div
              class="ui mini icon red button"
              :data-tooltip="$t('delete')"
              @click="remove(item, idx)"
            >
              <i class="trash icon"></i>
            </div>
            <div
              class="ui mini icon blue button"
              :data-tooltip="$t('manage')"
              @click="manage(item)"
            >
              <i class="setting icon"></i>
            </div>
            <div
              class="ui mini icon orange button"
              :data-tooltip="$t('track')"
              @click="track(item)"
            >
              <i class="eye icon"></i>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div ref="modals">
      <template v-for="(mdl, index) in tracking_modals">
        <component
          :is="mdl"
          :key="index"
          :instance_id="tracking_instance_id"
          @destroy="destroyed"
        ></component>
      </template>
      <template v-for="(mdl, index) in manage_modals">
        <component
          :is="mdl"
          :key="index"
          :instance_id="tracking_instance_id"
          @destroy="destroyed"
        ></component>
      </template>
    </div>
  </div>
</template>

<script>
import "datatables.net";
import "datatables.net-se";
import { local_api, error_toast, enterprise_setup } from "@/utils";
import filters from "@/filters";
import InstanceTracker from "@/modules/ngine_workspace/NgineInstanceTrackingModal";
import InstanceManager from "@/modules/ngine_core/process/instance_manager/NgineInstanceManagerModal";
import moment from "moment";

export default {
  name: "InstanceTracker",
  filters: filters,
  props: { process: Object },
  data() {
    return {
      start_date: "",
      end_date: "",
      items: [],
      tracking_modals: [],
      manage_modals: [],
      tracking_instance_id: "",
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  mounted() {
    let vm = this;

    window.jQuery(vm.$refs.range_start).calendar({
      today: true,
      type: "datetime",
      endCalendar: window.jQuery(vm.$refs.range_end),
      onSelect(value) {
        vm.start_date = value;
      },
    });
    window.jQuery(vm.$refs.range_end).calendar({
      today: true,
      type: "datetime",
      startCalendar: window.jQuery(vm.$refs.range_start),
      onSelect(value) {
        vm.end_date = value;
      },
    });

    let now = moment().toISOString();
    let start_of_day = moment().startOf("day").toISOString();
    console.log(start_of_day, now);

    setTimeout(() => {
      window.jQuery(vm.$refs.range_start).calendar("set date", start_of_day);
      window.jQuery(vm.$refs.range_end).calendar("set date", now);
      vm.start_date = start_of_day;
      vm.end_date = now;
    }, 200);
  },
  methods: {
    search() {
      let vm = this;
      local_api(vm, "post", "/ngine_core/process/do-search-instances", {
        i: vm.process.uuid,
        s: vm.start_date,
        e: vm.end_date,
      })
        .then((instances) => {
          vm.items = instances;
          // window.jQuery(vm.$refs.table).DataTable();
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    status(status_code) {
      if (status_code == "C")
        return { name: this.$t("created"), icon: "bullseye icon" };
      else if (status_code == "R")
        return { name: this.$t("running"), icon: "loading cog icon" };
      else if (status_code == "W")
        return { name: this.$t("waiting"), icon: "clock outline icon" };
      else if (status_code == "E")
        return { name: this.$t("errored"), icon: "remove icon" };
      else if (status_code == "F")
        return { name: this.$t("finished"), icon: "check icon" };
      else return { name: "?", icon: "question mark icon" };
    },
    activity(interaction) {
      if (!interaction) return { name: "-", icon: "asterisk icon" };
      let component = JSON.parse(interaction.component);

      if (component.$type == "bpmn:UserTask")
        return {
          name: component.name || interaction.component_name || component.$type,
          icon: "user icon",
        };
      else if (component.$type == "bpmn:StartEvent")
        return {
          name: component.name || interaction.component_name || component.$type,
          icon: "bullseye icon",
        };
      else if (component.$type == "bpmn:SequenceFlow")
        return {
          name: component.name || interaction.component_name || component.$type,
          icon: "right arrow icon",
        };
      else if (component.$type == "bpmn:EndEvent")
        return {
          name: component.name || interaction.component_name || component.$type,
          icon: "flag checkered icon",
        };
      else if (component.$type == "bpmn:SubProcess")
        return {
          name: component.name || interaction.component_name || component.$type,
          icon: "setting icon",
        };
      else if (
        component.$type == "bpmn:ServiceTask" &&
        component.custom_type == "AutomatonCall"
      )
        return {
          name: component.name || interaction.component_name || component.$type,
          icon: "settings icon",
        };
      else return { name: "?", icon: "question mark icon" };
    },
    track(instance) {
      this.tracking_instance_id = instance.uuid;
      this.tracking_modals.push(InstanceTracker);
    },
    manage(instance) {
      this.tracking_instance_id = instance.uuid;
      this.manage_modals.push(InstanceManager);
    },
    remove(instance, index) {
      let vm = this;

      vm.$alertify.confirm(
        vm.$t("are you sure to remove instance?"),
        function () {
          local_api(vm, "post", "/ngine_core/instance/do-remove", {
            u: instance.uuid,
          })
            .then(() => {
              vm.items.splice(index, 1);
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    destroyed() {
      this.tracking_modals = [];
    },
  },
};
</script>
